<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nDXJah/tc-custom/9781625847812.jpg?1705026066161" alt="This image is the cover for the book Wicked Grand Rapids, Wicked"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wicked Grand Rapids, Wicked
      </h1>
      <p class="bookDescription body article font2">
        <p>Investigate the citizens of Grand Rapids, even those above suspicion, with author and local history enthusiast Amberrose Hammond as she uncovers a seedy cast of characters from the city's past. Meet career criminals like Clem Blood, who tore off all his clothes during sentencing, only to be presented with a new suit at public expense. Open a love letter from Grand Rapids' own Lonely Hearts killer, who lured his victims by direct mail. Unseal the habeas corpus proceedings for the gruesome details of what the "Grand Rapids Press" called "the most cold blooded crime in the history of the city." Stay out of the shadows, keep your doors locked and enjoy delving into the wicked side of the Furniture City.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amberrose Hammond
      </h2>
      
      <p class="authorDescription body article">Amberrose Hammond earned her degree in English at Grand Valley State University in 2005. She has been actively researching and investigating paranormal phenomena since 2000. She has traveled around the United States and Michigan exploring haunted locations and legends and is an avid local history and historical cemetery enthusiast. She enjoys tiptoeing around old tombstones whenever she spots a new cemetery to discover. Amberrose is co-founder, along with Tom Maat, of the popular website Michigan's Otherside, which showcases Michigan's strange and paranormal world. Together, they lecture about their paranormal pursuits and enjoy sharing Michigan's mysterious side during the Halloween season with fellow Michiganders.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5a236300